<po-page-list #poPageListComponent
  p-title="Controle de Qualiade - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
  [p-actions]="actions"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ04DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ04DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>

    <po-datepicker
      class="po-md-6"
      name="DZ04DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ04DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>

    <po-input
      class="po-md-6"
      name="CZ04LOTE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ04LOTE"
      p-label="Lote"
      [p-maxlength]="6"
    ></po-input>

    <po-select
      class="po-md-6"
      name="CZ04STATUS"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ04STATUS"
      p-label="Status"
      [p-options]="varStatus"
    ></po-select>

  </form>
</po-modal>

<po-modal #modalEditar p-title="Editar Motivo" [p-primary-action]="modalEditarAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-12"
      name="motivoEditar"
      [(ngModel)]="motivoEditar"
      p-label="Motivo da Reprovação"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="zprColumnsFilters"
      [p-field-format]="zprFieldFormaterFilters"
      [p-filter-service]="zprService"
      [p-advanced-filters]="zprAdvancedFilters"
      [p-literals]="{ modalTitle: 'Motivo da Reprovação' }"
      [p-required]="true"
      [p-auto-height]="true">
    </po-lookup>
  </form>
</po-modal>
